import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';
import { ConfigurationService } from '../shared/services/configuration.service';
import { BudgetModel } from '../models/budget.model';
import { Guid } from 'guid-typescript';
import { InterestRateModel } from '../models/interestRate.model';
import { BudgetOptionalAccessory } from '../models/budget-optional-accessory.model';
import { BudgetListModel } from '../models/budget-list.model';

@Injectable({
  providedIn: 'root',
})
export class BudgetService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private readonly backUrl;
  private readonly popopSubject = new Subject<void>();

  constructor() {
    this.backUrl = `${this.configSvc.workloadsApiUrl}api`;
  }

  // Interest management
  getInterestRateById(id: string): Observable<InterestRateModel> {
    return this.http.get<InterestRateModel>(
      `${this.backUrl}/Budget/InterestRateInstallment/${id}`
    );
  }

  getAllInterestRate(): Observable<Array<InterestRateModel>> {
    return this.http.get<Array<InterestRateModel>>(
      `${this.backUrl}/Budget/InterestRateInstallment`
    );
  }

  createInterest(plan: InterestRateModel): Observable<any> {
    return this.http.post(`${this.backUrl}/Budget/InterestRateInstallment`, {
      description: plan.description,
      installments: plan.installments,
      interestRate: plan.interestRate,
      isActive: plan.isActive,
    });
  }

  updateInterest(plan: InterestRateModel): Observable<any> {
    return this.http.patch(
      `${this.backUrl}/Budget/InterestRateInstallment/${plan.id}`,
      {
        description: plan.description,
        installments: plan.installments,
        interestRate: plan.interestRate,
        isActive: plan.isActive,
      }
    );
  }

  deleteInterestPlan(id: Guid): Observable<any> {
    return this.http.delete(
      `${this.backUrl}/Budget/InterestRateInstallment/${id}`
    );
  }

  activeInterestPlan(id: string, isActive: boolean): Observable<any> {
    return this.http
      .patch(`${this.backUrl}/Budget/InterestRateInstallment/${id}/active`, {
        isActive: isActive,
      })
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  // Budget
  getAllBudget(
    initDate?: string,
    finalDate?: string
  ): Observable<Array<BudgetListModel>> {
    if (initDate != undefined && finalDate != undefined) {
      const params = new HttpParams()
        .set('from', initDate)
        .set('to', finalDate);
      return this.http.get<Array<BudgetListModel>>(
        `${this.backUrl}/Budget?${params}`
      );
    } else {
      return this.http.get<Array<BudgetListModel>>(`${this.backUrl}/Budget`);
    }
  }

  getBudgetById(id: string): Observable<BudgetModel> {
    return this.http.get<BudgetModel>(`${this.backUrl}/Budget/${id}`);
  }

  updateBudget(id: string, budgetEdited: any) {
    return this.http.patch(`${this.backUrl}/Budget/${id}`, budgetEdited);
  }

  // Accesorios opcionales
  getAllAccesories(): Observable<Array<BudgetOptionalAccessory>> {
    return this.http.get<Array<BudgetOptionalAccessory>>(
      `${this.backUrl}/Budget/optionalAccessory`
    );
  }

  updateOptionaAccesory(objEdited: any) {
    return this.http.patch(
      `${this.backUrl}/Budget/optionalAccessory/${objEdited.id}`,
      objEdited
    );
  }

  private createQuery(params?: any): string {
    let query = '';

    if (params) {
      Object.keys(params).forEach((prop) => {
        if (params[prop]) {
          if (params[prop] instanceof Array) {
            (params[prop] as number[]).forEach((x) => {
              query += `${prop}=${x}&`;
            });
          } else {
            query += `${prop}=${params[prop]}&`;
          }
        }
      });
    }
    return query.slice(0, -1);
  }
}
